import { Dropdown, Menu, Button } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import AuthStore from "../../../stores/AuthStore";
import styles from "./index.module.scss";
import { useNavigate } from "react-router";
const PageHeader: React.FC = (props) => {
  const { account } = AuthStore;
  const navigate = useNavigate();
  return (
    <header className={styles.page_header}>
      <span className={styles.web_title}>统一登录配置中心</span>
      <div>
        <Button
          // shape="round"
          type="primary"
          onClick={() => {
            navigate("/user/cards");
          }}
          style={{marginRight:'24px'}}
        >
          用户页面
        </Button>
        <Dropdown
          overlay={
            <Menu
              onClick={(e) => {
                if (e.key === "logout") {
                  AuthStore.logout();
                }
              }}
              items={[{ label: "退出", key: "logout" }]}
            />
          }
        >
          <span className={styles.user_info}>{account}</span>
        </Dropdown>
      </div>
    </header>
  );
};

export default observer(PageHeader);
